import { isNotNilOrEmpty, setTrackingId } from "client/Misc/utils";
import { PropsWithChildren, ReactElement } from "react";
import styles from "./PersonalInformationPage.module.less";
import classNames from "classnames";
import { PersonalInformationBanner, PersonalInformationBannerProps } from "./PersonalInformationBanner";

export type PersonalInformationPageProps = {
	trackingId: string;
};

export const PersonalInformationPage = (props: PropsWithChildren<PersonalInformationPageProps>): ReactElement => {
	const {
		trackingId,
		children
	} = props;

	return (
		<article
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			{children}
		</article>
	);
};
PersonalInformationPage.displayName = "PersonalInformationPage";

type SectionProps = {
	title?: string;
	trackingId: string;
};

const Section = (props: PropsWithChildren<SectionProps>): ReactElement => {
	const {
		title,
		trackingId,
		children
	} = props;

	return (
		<section
			{...setTrackingId(trackingId)}
			className={styles.section}
		>
			{isNotNilOrEmpty(title) && (
				<h4 className={styles.sectionHeader}>{title}</h4>
			)}
			{children}
		</section>
	);
};
Section.displayName = "PersonalInformationPage.Section";

type BannerProps = PersonalInformationBannerProps & {
	trackingId: string;
};

const Banner = (props: BannerProps): ReactElement => {
	const {
		trackingId,
		...bannerProps
	} = props;

	return (
		<header
			{...setTrackingId(trackingId)}
			className={classNames(
				styles.section,
				styles.section_wide,
				styles.section_noPadding
			)}
		>
			<PersonalInformationBanner
				trackingId="banner"
				{...bannerProps}
			/>
		</header>
	);
};
Banner.displayName = "PersonalInformationPage.Banner";

PersonalInformationPage.Section = Section;
PersonalInformationPage.Banner = Banner;
